import React, { useState } from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const tz = "America/Los_Angeles";

export default function Calendar({ month, attendDateList = [] }) {
  const selectedMonth = dayjs.tz(month, tz);
  const [now, setNow] = useState(dayjs().tz(tz));
  const [firstDay, setFirstDay] = useState(selectedMonth.startOf("month"));
  const [lastDay, setLastDay] = useState(selectedMonth.endOf("month"));

  // check now month is selected month
  const isNowMonth = selectedMonth.isSame(now, "month");

  const dateFormat = "YYYY-MM-DD";

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
  const dayOfWeeks = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const getCalendar = () => {
    // NOTE : Need to refactoring
    const calendar = [];

    let dayOfWeek = firstDay.day();
    let theDate = firstDay;

    theDate = theDate.date(theDate.date() - dayOfWeek - 1);
    while (true) {
      calendar.push(
        Array(7)
          .fill(1)
          .map((first, index) => {
            theDate = theDate.date(theDate.date() + 1);
            return theDate;
          })
      );
      if (theDate > lastDay) break;
    }
    return calendar;
  };

  const goPrevMonth = () => {
    const updateDay = firstDay.month(firstDay.month() - 1);
    setFirstDay(updateDay.startOf("month"));
    setLastDay(updateDay.endOf("month"));
  };

  const goNextMonth = () => {
    const updateDay = firstDay.month(firstDay.month() + 1);
    setFirstDay(updateDay.startOf("month"));
    setLastDay(updateDay.endOf("month"));
  };

  const checkRange = (date) => {
    return firstDay <= date && date <= lastDay;
  };

  const calendar = getCalendar();

  return (
    <div className="w-full">
      {/* <div className="flex flex-row justify-between lg:px-4 mb-2 lg:mb-6 items-end">
        <div>
          <h3 className="text-2xl font-bold">{months[firstDay.month()]}</h3>
        </div>
        <div>
          <ul className="flex flex-row flex-wrap -mx-1">
            <li className="px-1">오늘</li>
            <li className="px-1">출석</li>
          </ul>
        </div>
      </div> */}
      <div className="grid grid-rows-6 gap-1 lg:gap-4 xl:gap-6">
        <div className="grid grid-cols-7">
          {dayOfWeeks.map((day, index) => {
            return (
              <div
                key={(day, index)}
                className="w-full h-10 font-semibold flex items-center justify-center text-sm lg:text-base xl:text-xl text-gray-500"
              >
                {day}
              </div>
            );
          })}
        </div>
        {calendar.map((week, index) => {
          return (
            <div key={(week, index)} className="grid grid-cols-7 ">
              {week.map((date, index) => {
                const isDouble =
                  date.month() === selectedMonth.month() &&
                  (date.day() === 5 || date.day() === 6);

                return (
                  <div key={(date, index)}>
                    {
                      <div className="w-full h-full">
                        <div className="flex items-center justify-center w-full rounded-full">
                          <span
                            className={`inline-flex w-10 h-10 sm:w-12 sm:h-12 lg:w-14 lg:h-14 lg:text-xl text-sm sm:text-lg items-center justify-center font-bold relative ${
                              attendDateList.includes(date.format(dateFormat))
                                ? "bg-orange-500 text-white"
                                : isNowMonth && date.isSame(now, "day")
                                ? "ring-orange-500 ring-2"
                                : date.isBefore(now, "day")
                                ? "text-gray-400"
                                : "text-black "
                            }

                            rounded-full`}
                          >
                            {checkRange(date) ? date.date() : ""}
                            {isDouble && (
                              <span
                                className={`absolute top-0 -right-3 lg:-right-5 font-black border border-white text-white rounded-full text-[12px] lg:text-[14px] px-[6px] lg:px-[9px] leading-none py-[3px]
                              ${
                                date.isBefore(now, "day")
                                  ? attendDateList.includes(
                                      date.format(dateFormat)
                                    )
                                    ? "bg-orange-500"
                                    : "bg-gray-400"
                                  : "bg-orange-500"
                              }
                              `}
                              >
                                x2
                              </span>
                            )}
                          </span>
                        </div>
                      </div>
                    }
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}